import { EntityModel } from '@/interfaces'
import {
  ALL_CUSTOMER_ESIMS_QUERY,
  CREATE_CUSTOMER_ESIM_MUTATION,
  DELETE_CUSTOMER_ESIM_MUTATION,
  FORCE_DELETE_CUSTOMER_ESIM_MUTATION,
  SINGLE_CUSTOMER_ESIM_QUERY,
  UPDATE_CUSTOMER_ESIM_MUTATION,
} from './graphql'

const customerEsimModel: EntityModel = {
  name: 'customerEsim',
  namePlural: 'customerEsims',
  uniqueName: 'customerEsim',
  uniqueNamePlural: 'customerEsims',
  path: 'travel/booking/customer_esim',
  baseUrl: '/travel/booking/customer_esims',
  translationPrefix: 'entities:customerEsim.',
  getDisplayName: (values: any) => {
    return values.referenceNo
  },
  gql: {
    getAll: ALL_CUSTOMER_ESIMS_QUERY,
    getSingle: SINGLE_CUSTOMER_ESIM_QUERY,
    create: CREATE_CUSTOMER_ESIM_MUTATION,
    update: UPDATE_CUSTOMER_ESIM_MUTATION,
    delete: DELETE_CUSTOMER_ESIM_MUTATION,
    forceDelete: FORCE_DELETE_CUSTOMER_ESIM_MUTATION,
  },
  attributes: {
    referenceNo: {
      name: 'referenceNo',
      label: 'entities:customerEsim.attributes.referenceNo.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    serviceName: {
      name: 'serviceName',
      label: 'entities:customerEsim.attributes.serviceName.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    label: {
      name: 'label',
      label: 'entities:customerEsim.attributes.label.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    purchaseId: {
      name: 'purchaseId',
      label: 'entities:customerEsim.attributes.purchaseId.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    iccid: {
      name: 'iccid',
      label: 'entities:customerEsim.attributes.iccid.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    startDate: {
      name: 'startDate',
      label: 'entities:customerEsim.attributes.startDate.label',
      type: 'value',
      dataType: 'Date',
      defaultInput: true,
      inputType: 'text',
      isStartDate: true,
      endDateAttribute: '',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    endDate: {
      name: 'endDate',
      label: 'entities:customerEsim.attributes.endDate.label',
      type: 'value',
      dataType: 'Date',
      defaultInput: true,
      inputType: 'text',
      isEndDate: true,
      startDateAttribute: '',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
  },
}

export default customerEsimModel
